import * as React from 'react'
import { graphql } from 'gatsby'

import Layout from 'src/dlc_components/layout'
import LearningObjectList from 'src/dlc_components/learningObjectList'
import { title_sort_learning_objects } from 'src/dlc_utils/arrays'

const CategoryTaxonomyPage = ( props ) => {
	const item = props.data.item;

	const breadcrumbs = [
		{ 
			url: "",
			title: "Home",
		},
	]

	const learning_object_list = title_sort_learning_objects(item.relationships.node__dlc_content);

    return (
      <Layout breadcrumbs={breadcrumbs} title={item.name} bodyClass='taxonomy-page'>
			<div>
				<LearningObjectList object_list={ learning_object_list } per_page={999}/>
			</div>
      </Layout>
    )
}

export const query = graphql`
	query CategoryTaxonomyPageQuery ($id: String) {
		item: taxonomyTermDlcCategory(id: {eq: $id}) {
			id
			name
			relationships {
				node__dlc_content {
					field_dlc_thumbnail {
						alt
					}
					relationships {
						field_dlc_thumbnail {
							localFile {
								childImageSharp {
									gatsbyImageData(height: 300, width: 300)
								}
							}
						}
					}
					path {
						alias
					}
					title
				}
			}
		}
	}
`

export default CategoryTaxonomyPage;